import {Component, OnInit, HostListener, Input, ViewChild, ElementRef} from '@angular/core';
import {BarChartConfigurations} from "../../charts/bar-chart/bar-chart.models";
import {TitleConfigurations, TitleLineConfigurations} from "../title/title.configurations";
import {KlaHttpService} from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { AudioComponent } from '../audio/audio.component';
import { TitleComponent } from '../title/title.component';
import { BarChartComponent } from 'app/shared/charts/bar-chart/bar-chart.component';

@Component({
  selector: 'kla-complex-bar-graph',
  templateUrl: './complex-bar-graph.component.html',
  styleUrls: ['./complex-bar-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule, AudioComponent, TitleComponent, BarChartComponent ]
})
export class ComplexBarGraphComponent implements OnInit {

  @Input()
  public width: number;

  @Input()
  public height: number;

  @Input()
  public config: {
    barChart: BarChartConfigurations,
    title: TitleConfigurations,
    audio: { url: string; image: string; text: string; },
    chartId: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  @ViewChild('panel', {static: true})
  public panel:ElementRef;

  constructor(private http: KlaHttpService) { }

  ngOnInit() {
    this.http.getChartData("kla-bar-chart", this.config.chartId).subscribe(
      (data) => {
        this.config.barChart = data;
        if (!this.config.barChart) {
          console.error("Please provide bar chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }

  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();
    let width = rectangle.width - 60;
    width  = width < 450 ? 450 : width;
    this.width = width;
    this.height = width*2/3;
  }
}
